<div class="page-title-area item-bg2">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="/" i18n>Home</a></li>
                <li i18n>Contact</li>
                <li></li>
            </ul>
            <h2 i18n>Contact Us</h2>
        </div>
    </div>
</div>

<div
    class="contact-info-area pt-100 pb-70"
    [class.dark-contact-info-area]="themeService.isDark()"
>
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="contact-info-box mb-30">
                    <div class="icon">
                        <i class='bx bx-envelope'></i>
                    </div>
                    <h3 i18n>Email Here</h3>
                    <p>
                        <a href="mailto:aleshansab&#64;gmail.com">aleshansab&#64;gmail.com</a>
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="contact-info-box mb-30">
                    <div class="icon">
                        <i class='bx bx-map'></i>
                    </div>
                    <h3 i18n>Location Here</h3>
                    <p><a>Firozkoh, Ghor, Afghanistan</a></p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                <div class="contact-info-box mb-30">
                    <div class="icon">
                        <i class='bx bx-phone-call'></i>
                    </div>
                    <h3 i18n>Call Here</h3>
                    <p><a href="tel:+447447419596">+447447419596</a></p>
                    <p><a href="tel:+4915771009570">+4915771009570</a></p>
                </div>
            </div>
        </div>
    </div>
</div>
